export const sanitizeNumericInput = (value: string, decimalPlaces?: number): string => {
    const cleaned = value.replace(/[^\d.,]/g, '');
    if (!cleaned) return '';

    if (decimalPlaces === 0) {
        return cleaned.replace(/[.,]/g, '');
    }

    const separatorIndex = cleaned.search(/[.,]/);
    if (separatorIndex === -1) {
        return cleaned;
    }

    const intPart = cleaned.slice(0, separatorIndex);
    const separator = cleaned[separatorIndex];
    let fracPart = cleaned.slice(separatorIndex + 1).replace(/[.,]/g, '');

    if (decimalPlaces !== undefined) {
        fracPart = fracPart.slice(0, decimalPlaces);
    }

    const trailingSeparator = cleaned.endsWith('.') || cleaned.endsWith(',');
    if (trailingSeparator && fracPart === '') {
        return `${intPart}${separator}`;
    }

    return fracPart ? `${intPart}${separator}${fracPart}` : intPart;
};

export const toParseableNumberString = (value: string): string =>
    sanitizeNumericInput(value).replace(',', '.');
